import { CornerSize, Island, Kitchen, Size } from '..';

import { emptyIslandDefaults, EmptyIslandDefaults } from './empty-island-defaults';

// eslint-disable-next-line max-params
export const newEmptyIsland = (kitchen: Kitchen, islandType: EmptyIslandDefaults, angle: number, isDefault = false): Island => {
	const details = emptyIslandDefaults[islandType];
	const island = kitchen.design.islands.newIsland(details.type, { width: details.width, height: details.height, depth: details.depth } as (Size | CornerSize));

	island.setBackOverhang(details.countertopOverhang);
	kitchen.design.countertops.new(island.id);

	if (isDefault) kitchen.design.islands.setDefaultIsland(island.id);
	island.axis.y = angle;

	return island;
};
